<template>
  <Container :title="title" :subtitle="subtitle" @on-submit="$emit('on-submit')">
    <template #form>
      <v-form ref="form" @submit.prevent>
        <div v-for="(grupo, nomeCategoria) in perguntasAgrupadas" :key="nomeCategoria">
          <h3 class="text-left title primary--text mt-5">
            <strong>{{ nomeCategoria }}</strong>
          </h3>
          <v-row>
            <v-col cols="12" md="6" v-for="pergunta in grupo" :key="pergunta.id">
              <component
                :is="capitalizeText(pergunta.input)"
                :type="pergunta.type"
                :text="pergunta.text"
                :options="pergunta.options"
                :justify="pergunta.justify"
                :justify-all="pergunta.justifyAll"
                :required="pergunta.required"
                :no-required="pergunta.noRequired"
                v-model="respostas[pergunta.id].value"
              />
            </v-col>
          </v-row>
        </div>
      </v-form>
    </template>
    <ConfirmDialog
      v-if="confirmDialog"
      v-model="confirmDialog"
      title="Deseja sair?"
      text="Os dados preenchidos serão perdidos."
      cancelButtonText="Continuar preenchendo"
      confirmButtonText="Sair"
      @on-confirm="confirmarSaida"
      @on-cancel="confirmDialog = false"
    />
  </Container>
</template>

<script>
import { capitalizeText } from '@/utils/formatter'

const Container = () => import('@/modules/AvaliacaoPsicossocial/AvaliacaoPsicossocialContainer')
const ConfirmDialog = () => import('@/core/components/ConfirmDialog')
const Radio = () => import('@/modules/AvaliacaoPsicossocial/AvaliacaoPsicossocialRadio')

export default {
  components: {
    Container,
    Radio,
    ConfirmDialog
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    perguntas: {
      type: Array,
      required: true
    },
    title: String,
    subtitle: String
  },
  data: () => ({
    capitalizeText,
    confirmDialog: false,
    nextRoute: null
  }),
  computed: {
    respostas: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    perguntasAgrupadas() {
      return this.perguntas.reduce((acc, pergunta) => {
        const nomeCategoria = pergunta.categoria.nome
        if (!acc[nomeCategoria]) {
          acc[nomeCategoria] = []
        }
        acc[nomeCategoria].push(pergunta)
        return acc
      }, {})
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    confirmarSaida() {
      this.confirmDialog = false

      if (this.nextRoute) {
        this.nextRoute()
        this.nextRoute = null
      }
    },

    abrirModalSaida(next) {
      this.nextRoute = next
      this.confirmDialog = true
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('111')
    this.abrirModalSaida(next)
  }
}
</script>
